import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'ariza-kaydi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--ariza" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">ARIZA KAYDI</div>
        <div class="ar-tur gc-baslik-ana">{{ p()?.arizaTuru || 'Arıza' }}</div>
        <div class="ar-alt">
          <span class="ar-sure">{{ p()?.sure || 0 }}h</span>
          @if (p()?.maliyet) { <span class="ar-maliyet">{{ maliyetFormatli() }}</span> }
        </div>
        @if (p()?.cozum) { <div class="ar-cozum">{{ p().cozum }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 45 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #dc2626; --accent-rgb: 220,38,38; }
    .ar-tur { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); }
    .ar-alt { display: flex; align-items: center; gap: 10px; margin-top: 2px; }
    .ar-sure { font-size: 18px; font-weight: 900; color: #f87171; font-variant-numeric: tabular-nums; text-shadow: 0 0 10px rgba(248,113,113,.3); }
    .ar-maliyet { font-size: 12px; font-weight: 700; color: #fbbf24; }
    .ar-cozum {
      font-size: 10px;
      color: var(--py-metin-ikincil, #64748b);
      line-height: 1.4;
      max-height: 80px;
      overflow-y: auto;
      overflow-x: hidden;
      white-space: normal;
      word-wrap: break-word;
      padding: 2px 4px;
      background: rgba(0,0,0,0.15);
      border-radius: 3px;
    }
    .ar-cozum::-webkit-scrollbar {
      width: 4px;
    }
    .ar-cozum::-webkit-scrollbar-track {
      background: transparent;
    }
    .ar-cozum::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.3);
      border-radius: 2px;
    }
    .ar-cozum::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.5);
    }
  `],
})
export class ArizaKaydiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  maliyetFormatli = computed(() => {
    const m = this.p()?.maliyet;
    if (!m) return '';
    return Number(m).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  });
}
